var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyConverter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5H16C16.55 12.5 17 12.05 17 11.5V5.5C17 4.95 16.55 4.5 16 4.5H13C12.45 4.5 12 4.95 12 5.5V11.5C12 12.05 12.45 12.5 13 12.5ZM14 6.5H15V10.5H14V6.5ZM7 12.5H10C10.55 12.5 11 12.05 11 11.5V5.5C11 4.95 10.55 4.5 10 4.5H7C6.45 4.5 6 4.95 6 5.5V11.5C6 12.05 6.45 12.5 7 12.5ZM8 6.5H9V10.5H8V6.5ZM3 4.5H5V12.5H3V4.5ZM0 0.5V16.5H20V0.5H0ZM18 14.5H2V2.5H18V14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyConverter);
export default __webpack_public_path__ + "static/media/CurrencyConverter.1decbf0705248705cc683c56e5d9a46b.svg";
export { ForwardRef as ReactComponent };